/*
  TrofeaSklep – przewagi (wersja 6, terminy z 26.10.2026):
  - przewidywana data wysyłki na karcie produktu (dni robocze z polskimi świętami),
  - przypięty pasek „Dodaj do koszyka” na telefonie,
  - w koszyku: „Na kiedy potrzebujesz nagród?” (atrybut zamówienia), Ekspres (+30%, wysyłka w 24 h, z personalizacją od 48 h)
    i wysyłka koszyka do akceptacji e-mailem,
  - komplet I–III z trzema napisami (produkty z tagiem „komplet miejsc 1–3”).
  Moduł ładowany z kilku fragmentów motywu; przeglądarka wykonuje go tylko raz.
*/

const MONTHS = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
const DAYS = ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'];
const NEED_KEY = 'Potrzebne na';
const EXPRESS_KEY = 'Ekspres';
const EXPRESS_VALUE = 'tak – wysyłka w 24 h (z personalizacją od 48 h od akceptacji projektu), dopłata 30% wartości produktów';
const ROOT = () => (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

function easter(y) {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
  const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(y, month - 1, day);
}

const holidayCache = {};
function holidays(y) {
  if (holidayCache[y]) return holidayCache[y];
  const e = easter(y);
  const add = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
  // Dni ustawowo wolne w Polsce (od 2025 r. także Wigilia).
  const list = [
    new Date(y, 0, 1), new Date(y, 0, 6), e, add(e, 1), new Date(y, 4, 1), new Date(y, 4, 3),
    add(e, 49), add(e, 60), new Date(y, 7, 15), new Date(y, 10, 1), new Date(y, 10, 11),
    new Date(y, 11, 24), new Date(y, 11, 25), new Date(y, 11, 26)
  ];
  holidayCache[y] = new Set(list.map((d) => d.toDateString()));
  return holidayCache[y];
}

export function isWorkday(d) {
  const wd = d.getDay();
  if (wd === 0 || wd === 6) return false;
  return !holidays(d.getFullYear()).has(d.toDateString());
}

export function addWorkdays(from, n) {
  const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  let k = 0;
  while (k < n) {
    d.setDate(d.getDate() + 1);
    if (isWorkday(d)) k++;
  }
  return d;
}

export function formatDay(d) {
  return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
}

function isoDate(d) {
  const p = (n) => String(n).padStart(2, '0');
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
}

function parseIso(s) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
  return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
}

const money = (cents) => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format((cents || 0) / 100);

/* ---------- Data wysyłki na karcie produktu ---------- */

function persoActive(scope) {
  const box = (scope || document).querySelector('[data-ts-perso]');
  return !!(box && !box.hidden);
}

function renderShipDate(el) {
  const today = new Date();
  const days = parseInt(el.dataset.days || '3', 10);
  const daysPerso = parseInt(el.dataset.daysPerso || '5', 10);
  const long = el.dataset.long === '1';
  const text = el.querySelector('[data-ts-ship-text]');
  if (!text) return;
  const scope = el.closest('section') || document;
  if (long) {
    // Serie realizowane na zamówienie (np. Amber Line): od 7 dni roboczych, bez Ekspresu – bez obietnicy konkretnej daty.
    text.innerHTML = 'Seria realizowana na zamówienie: wysyłka od <strong>' + daysPerso + ' dni roboczych</strong>' + (persoActive(scope) ? ' od akceptacji projektu' : '') + '.';
  } else if (persoActive(scope)) {
    text.innerHTML = 'Z personalizacją: wysyłka do ' + daysPerso + ' dni roboczych od akceptacji projektu – przy akceptacji dziś najpóźniej <strong>' + formatDay(addWorkdays(today, daysPerso)) + '</strong>.';
  } else {
    text.innerHTML = 'Zamów dziś – wyślemy najpóźniej <strong>' + formatDay(addWorkdays(today, days)) + '</strong>.';
  }
  el.hidden = false;
}

function initShipDates() {
  document.querySelectorAll('[data-ts-ship-date]').forEach((el) => {
    if (el.dataset.tsReady) return;
    el.dataset.tsReady = '1';
    renderShipDate(el);
    const scope = el.closest('section') || document;
    const box = scope.querySelector('[data-ts-perso]');
    if (box) new MutationObserver(() => renderShipDate(el)).observe(box, { attributes: true, attributeFilter: ['hidden'] });
  });
}

/* ---------- Przypięty pasek „Dodaj do koszyka” (telefon) ---------- */

function initStickyAtc() {
  const bar = document.querySelector('[data-ts-satc]');
  if (!bar || bar.dataset.tsReady) return;
  bar.dataset.tsReady = '1';
  // Przenosimy pasek do <body>, żeby żaden przodek z transformacją (animacje przewijania) nie psuł position: fixed.
  if (bar.parentElement !== document.body) document.body.appendChild(bar);
  const section = document.querySelector('section[id^="ProductInfo-"]') || document.querySelector('[id^="MainProduct-"]');
  const forms = section ? [...section.querySelectorAll('form[action*="/cart/add"]')] : [];
  const form = forms.find((f) => f.querySelector('button[type="submit"]'));
  const submit = form && form.querySelector('button[type="submit"]');
  if (!submit) return;
  const btn = bar.querySelector('[data-ts-satc-btn]');
  const priceEl = bar.querySelector('[data-ts-satc-price]');
  const hint = bar.querySelector('[data-ts-satc-hint]');
  const hintText = hint ? hint.textContent : '';
  const label = btn.textContent;
  const showHint = (msg) => {
    if (!hint) return;
    hint.textContent = msg;
    hint.hidden = false;
    clearTimeout(showHint.t);
    showHint.t = setTimeout(() => { hint.hidden = true; }, 4000);
  };

  const syncPrice = () => {
    const p = section.querySelector('[id^="price-"] .price-item--last, [id^="price-"] .price__regular .price-item--regular');
    if (p && priceEl) priceEl.textContent = p.textContent.trim();
    const soldOut = submit.disabled;
    btn.disabled = soldOut;
    btn.textContent = soldOut ? 'Niedostępny' : label;
  };

  let visible = false;
  const show = (on) => {
    if (on === visible) return;
    visible = on;
    bar.hidden = !on;
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.documentElement.classList.toggle('ts-satc-on', on);
    if (on) syncPrice();
  };

  const io = new IntersectionObserver((entries) => {
    const e = entries[0];
    show(!e.isIntersecting && e.boundingClientRect.top < 0);
  });
  io.observe(submit);

  const priceBox = section.querySelector('[id^="price-"]');
  if (priceBox) new MutationObserver(syncPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });

  btn.addEventListener('click', () => {
    const box = form.querySelector('[data-ts-perso]');
    if (box && !box.hidden && box.dataset.kind === 'puchar') {
      const fields = [...box.querySelectorAll('textarea')].filter((t) => !t.disabled);
      if (fields.length && fields.every((t) => !t.value.trim())) {
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => fields[0].focus({ preventScroll: true }), 400);
        showHint(hintText);
        return;
      }
    }
    const emb = form.querySelector('[data-ts-emblem]:not([hidden]) select');
    if (emb && !emb.disabled && !emb.value) {
      emb.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => emb.focus({ preventScroll: true }), 400);
      showHint('Wybierz wzór emblematu – bez niego nie dodamy pucharu do koszyka.');
      return;
    }
    submit.click();
  });
}

/* ---------- Koszyk: termin i wysyłka do akceptacji ---------- */

function cartNeedHint(wrap) {
  const input = wrap.querySelector('[data-ts-need]');
  const hint = wrap.querySelector('[data-ts-need-hint]');
  if (!input || !hint) return;
  const need = parseIso(input.value);
  if (!need) { hint.textContent = ''; hint.className = 'ts-cx__hint'; return; }
  const perso = wrap.dataset.perso === '1';
  const long = wrap.dataset.long === '1';
  const exp = wrap.querySelector('[data-ts-express]');
  const express = !!(exp && exp.checked) && !long;
  // Terminy z 26.10.2026: bez personalizacji do 3 dni roboczych, z personalizacją do 5 dni od akceptacji projektu,
  // serie na zamówienie od 7 dni; Ekspres – wysyłka w 24 h (1 dzień roboczy), z personalizacją od 48 h (2 dni robocze).
  const days = long ? 7 : (express ? (perso ? 2 : 1) : (perso ? 5 : 3));
  const shipBy = addWorkdays(new Date(), days);
  // Kurier doręcza w dzień roboczy po nadaniu – termin wcześniejszy niż ten dzień jest zagrożony (np. sobotni turniej przy wysyłce w piątek).
  const deliverMin = addWorkdays(new Date(), days + 1);
  if (need < deliverMin) {
    hint.innerHTML = 'To krótki termin. Zadzwoń, a sprawdzimy możliwość szybszej realizacji: <a href="tel:+48509677677">+48 509 677 677</a>.';
    hint.className = 'ts-cx__hint ts-cx__hint--warn';
  } else {
    hint.innerHTML = long
      ? 'Zanotowane. Serie realizowane na zamówienie wysyłamy od 7 dni roboczych – termin potwierdzimy po zamówieniu.'
      : 'Zanotowane. Wyślemy najpóźniej <strong>' + formatDay(shipBy) + '</strong>' + (perso ? ' (przy akceptacji projektu dziś)' : '') + (express ? ' – Ekspres, po potwierdzeniu terminu' : '') + '.';
    hint.className = 'ts-cx__hint ts-cx__hint--ok';
  }
}

async function saveExpress(input) {
  const wrap = input.closest('[data-ts-cx]');
  try {
    await fetch(ROOT() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [EXPRESS_KEY]: input.checked ? EXPRESS_VALUE : '' } })
    });
    document.querySelectorAll('[data-ts-express]').forEach((other) => { if (other !== input) other.checked = input.checked; });
  } catch (e) { /* zapis nieudany */ }
  document.querySelectorAll('[data-ts-cx]').forEach((w) => {
    w.classList.toggle('is-express', input.checked);
    cartNeedHint(w);
  });
  if (wrap) wrap.classList.toggle('is-express', input.checked);
}

async function saveNeed(input) {
  const wrap = input.closest('[data-ts-cx]');
  try {
    await fetch(ROOT() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [NEED_KEY]: input.value || '' } })
    });
    document.querySelectorAll('[data-ts-need]').forEach((other) => { if (other !== input) other.value = input.value; });
  } catch (e) { /* zapis nieudany – pole zostaje, klient może wpisać termin w uwagach */ }
  if (wrap) cartNeedHint(wrap);
}

function cartSummary(cart) {
  const lines = ['Dzień dobry,', 'przesyłam koszyk z trofera.pl do akceptacji:', ''];
  cart.items.forEach((it, i) => {
    lines.push((i + 1) + '. ' + it.product_title);
    if (it.variant_title) lines.push('   Wariant: ' + it.variant_title);
    lines.push('   Ilość: ' + it.quantity + ' × ' + money(it.final_price) + ' = ' + money(it.final_line_price));
    const props = it.properties || {};
    Object.keys(props).forEach((k) => {
      if (k.charAt(0) === '_' || !props[k]) return;
      const v = String(props[k]);
      if (/^https?:\/\//.test(v)) { lines.push('   ' + k + ': (plik przesłany do sklepu)'); return; }
      lines.push('   ' + k + ': ' + v.replace(/\r?\n/g, ' / '));
    });
  });
  lines.push('');
  if (cart.total_discount > 0) lines.push('Rabat: −' + money(cart.total_discount));
  lines.push('Razem (z VAT, bez dostawy): ' + money(cart.total_price));
  if (cart.attributes && cart.attributes[EXPRESS_KEY]) lines.push('Ekspres: wysyłka w 24 h (z personalizacją od 48 h), dopłata 30% wartości produktów (' + money(Math.round(cart.items_subtotal_price * 0.3)) + ') – po potwierdzeniu terminu');
  if (cart.attributes && cart.attributes[NEED_KEY]) {
    const need = parseIso(cart.attributes[NEED_KEY]);
    lines.push('Potrzebne na: ' + (need ? formatDay(need) + ' ' + need.getFullYear() : cart.attributes[NEED_KEY]));
  }
  const links = cart.items.map((it, i) => (it.url ? (i + 1) + '. ' + location.origin + it.url : '')).filter(Boolean);
  if (links.length) {
    lines.push('');
    lines.push('Produkty w sklepie:');
    links.forEach((l) => lines.push(l));
  }
  lines.push('');
  lines.push('Po akceptacji złożę zamówienie z tego koszyka.');
  return lines.join('\n');
}

async function shareCart(mode, btn) {
  let cart;
  try { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) { return; }
  if (!cart || !cart.items || !cart.items.length) return;
  const body = cartSummary(cart);
  if (mode === 'mail') {
    window.location.href = 'mailto:?subject=' + encodeURIComponent('Koszyk do akceptacji – trofera.pl') + '&body=' + encodeURIComponent(body);
    return;
  }
  try {
    await navigator.clipboard.writeText(body);
    const old = btn.textContent;
    btn.textContent = 'Skopiowano';
    setTimeout(() => { btn.textContent = old; }, 2000);
  } catch (e) {
    window.prompt('Skopiuj podsumowanie koszyka:', body);
  }
}

function initCartExtras() {
  document.querySelectorAll('[data-ts-cx]').forEach(cartNeedHint);
  if (window.__tsCartExtras) return;
  window.__tsCartExtras = true;
  document.addEventListener('change', (e) => {
    const input = e.target.closest && e.target.closest('[data-ts-need]');
    if (input) saveNeed(input);
    const exp = e.target.closest && e.target.closest('[data-ts-express]');
    if (exp) saveExpress(exp);
  });
  document.addEventListener('click', (e) => {
    const mail = e.target.closest && e.target.closest('[data-ts-share-mail]');
    const copy = e.target.closest && e.target.closest('[data-ts-share-copy]');
    if (mail) shareCart('mail', mail);
    if (copy) shareCart('copy', copy);
  });
  // Szuflada koszyka odświeża swój HTML po zmianach – podpowiedź liczymy ponownie.
  new MutationObserver(() => document.querySelectorAll('[data-ts-cx]').forEach((w) => {
    if (!w.dataset.tsHint) { w.dataset.tsHint = '1'; cartNeedHint(w); }
  })).observe(document.body, { childList: true, subtree: true });
}

/* ---------- Komplet I–III z trzema napisami ---------- */

function initKomplet() {
  document.querySelectorAll('[data-ts-komplet]').forEach((box) => {
    if (box.dataset.tsReady) return;
    box.dataset.tsReady = '1';
    const rows = [...box.querySelectorAll('[data-ts-komplet-row]')];
    const btn = box.querySelector('[data-ts-komplet-add]');
    const totalEl = box.querySelector('[data-ts-komplet-total]');
    const msg = box.querySelector('[data-ts-komplet-msg]');
    const confirmBox = box.querySelector('[data-ts-komplet-confirm]');
    if (!rows.length || !btn) return;
    const textOf = (r) => r.querySelector('textarea').value.trim();
    const calc = () => {
      let sum = 0;
      rows.forEach((r) => { sum += parseInt(textOf(r) && r.dataset.tab ? r.dataset.tabPrice : r.dataset.basePrice, 10) || 0; });
      if (totalEl) totalEl.textContent = money(sum);
    };
    box.addEventListener('input', calc);
    if (confirmBox) confirmBox.addEventListener('change', () => box.classList.remove('needs-confirm'));
    calc();
    btn.addEventListener('click', async () => {
      const anyText = rows.some((r) => textOf(r));
      if (anyText && confirmBox && !confirmBox.checked) {
        box.classList.add('needs-confirm');
        confirmBox.focus();
        return;
      }
      const items = rows.map((r) => {
        const t = textOf(r);
        const item = { id: parseInt(t && r.dataset.tab ? r.dataset.tab : r.dataset.base, 10), quantity: 1 };
        if (t) item.properties = { 'Treść tabliczki': t, 'Treść sprawdzona': 'tak' };
        return item;
      });
      btn.disabled = true;
      if (msg) msg.textContent = 'Dodaję komplet…';
      try {
        const res = await fetch(ROOT() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'błąd koszyka');
        rows.forEach((r) => { r.querySelector('textarea').value = ''; });
        if (confirmBox) confirmBox.checked = false;
        calc();
        if (msg) msg.textContent = 'Dodano komplet do koszyka. Możesz dodać kolejny z innymi napisami.';
        const drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = ROOT() + 'cart';
        }
      } catch (e) {
        if (msg) msg.textContent = 'Nie udało się dodać kompletu (' + e.message + '). Spróbuj ponownie albo zadzwoń: +48 509 677 677.';
      }
      btn.disabled = false;
    });
  });
}

function initAll() {
  initShipDates();
  initStickyAtc();
  initCartExtras();
  initKomplet();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
else initAll();

export { isoDate };
